export const parseLiveMapHoursInput = (raw: string): number | undefined => {
  if (raw === "") {
    return undefined;
  }

  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return undefined;
  }

  return parsed;
};
